import React, { Component } from "react";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { isValidDate } from "./helpers";
import "react-day-picker/lib/style.css";

class FormDatepicker extends Component {
  state = {
    editing: false
  };

  editingStart = () => {
    this.setState({
      editing: true
    });
  };

  editingEnd = () => {
    this.setState({
      editing: false
    });
  };

  render() {
      const value = this.props.value
    return (
      <div
        className="formRow"
        onMouseOver={this.editingStart}
        onMouseLeave={this.editingEnd}
      >
        <label name={this.props.name}>
          {this.props.label || this.props.name}
          {this.props.error ? (
            <span className="error">{this.props.error}</span>
          ) : (
            ""
          )}
        </label>
        <div className="formRow-content">
          <DayPickerInput
            placeholder="MM/DD/YYYY"
            name={this.props.name}
            inputProps={{
              name: this.props.name,
              onChange: this.props.onChange
            }}
            dayPickerProps={{
              month: isValidDate(new Date(value)) ? new Date(value) : new Date(),
              toMonth: new Date(),
              disabledDays: new Date(value)
            }}
            onDayChange={this.props.onChange}
            value={value}
          />
          <button
            className={this.state.editing ? "" : "buttonHidden"}
            onClick={() => {
              this.props.onEmptyField(this.props.name);
            }}
          >
            <i className="ion-close-circled" />
          </button>
        </div>
      </div>
    );
  }
}

export default FormDatepicker;
